import DigitalBrochure from '~/js/components/general/brochure/DigitalBrochure';

const { resortList = [], cdnURL = ''} = window.beaches_app.page;

ReactDOM.render(
  <DigitalBrochure resortList={resortList} cdnURL={cdnURL} />,
  document.querySelector('#rct-digital-brochure')
);
